"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    // Sonar compliant for security-sensitive use cases
    var crypto = window.crypto;
    var array = new Uint32Array(1);
    return String(crypto.getRandomValues(array));
});
